
































































































































































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { SpecOutDetailsModule } from '@/store/modules/specOutDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import SpecOutContactDto from '@/models/SpecOuts/SpecOutContactDto';
import SpecOutStatus from '@/models/SpecOuts/SpecOutStatus';
import SpecOutContactStatus from '@/components/SpecOutContacts/Display/SpecOutContactStatus.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'SpecOutContacts',
  components: { SpecOutContactStatus },
})
export default class extends GiganautVue {

	page = 1;
	perPage = 8;
	selectedSpecOutContact: SpecOutContactDto = null;

	// Preview dialog state
	previewDialogVisible = false;
	previewSubject = '';
	previewBodyHtml = '';
	loadingPreview = false;

	get isSpecOutStatusDraft() {
		return SpecOutDetailsModule.currentSpecOut.status == SpecOutStatus.Draft;
	}

	get specOutContacts() {
		return SpecOutDetailsModule.specOutContacts;
	}

	get pagedSpecOutContacts() {
		return this.specOutContacts.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	async onPageChanged(input: number){
		this.selectedSpecOutContact = this.pagedSpecOutContacts[0];
	}

	async removeContact() {
		if (!this.selectedSpecOutContact) return;
		const options: VuetifyConfirmObject = {
			buttonTrueText: "REMOVE",
			buttonFalseText: "CANCEL",
			buttonTrueColor: "primary",
			buttonFalseColor: "primary",
		}
		const result = await this.$confirm('Are you sure you want to remove this contact from the spec out?', options);
		if (result) {
			const contactId = this.selectedSpecOutContact.contactId;
			await SpecOutDetailsModule.removeSpecOutContact(contactId);
			if (this.specOutContacts.length > 0) {
				this.selectedSpecOutContact = this.pagedSpecOutContacts[0];
			} else {
				this.selectedSpecOutContact = null;
			}
		}
	}

	async previewContact() {
		if (!this.selectedSpecOutContact) return;
		this.previewDialogVisible = true;
		this.loadingPreview = true;
		this.previewSubject = '';
		this.previewBodyHtml = '';

		const preview = await SpecOutDetailsModule.previewSpecOutContactEmail(this.selectedSpecOutContact.id);
		if (preview) {
			this.previewSubject = preview.subject;
			this.previewBodyHtml = preview.bodyHtml;
		}
		this.loadingPreview = false;
	}
}
